import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../shared/schemas.js';
import { publicAgentSchema } from '../agent/agent.schemas.js';
import { missionStatusCodeSchema } from '../mission/mission.schemas.js';
import { operationStatusCodeSchema } from './operation.schemas.js';

export const operationPublicIdSchema = z.string().trim().min(1);

// Ligne du classement public : l'agent et son parcours. Les ex aequo
// partagent le meme rang.
export const rankingEntrySchema = publicAgentSchema.extend({
  rank: z.number().int().positive(),
  statusCode: missionStatusCodeSchema,
  score: z.number().int().nonnegative(),
  endedAt: isoUtcDateTimeSchema.nullable(),
});

export type RankingEntry = z.infer<typeof rankingEntrySchema>;

// Page publique d'une operation : suivi et classement, ecran de victoire.
export const publicOperationSchema = z.object({
  publicId: z.string(),
  codeName: z.string(),
  statusCode: operationStatusCodeSchema,
  startsAt: isoUtcDateTimeSchema.nullable(),
  completedAt: isoUtcDateTimeSchema.nullable(),
  winner: publicAgentSchema.nullable(),
  ranking: z.array(rankingEntrySchema),
});

export type PublicOperation = z.infer<typeof publicOperationSchema>;


// Elimination d'une operation terminee, pour le rapport final (TD-021) :
// publiee seulement a COMPLETE, sinon elle revelerait le cycle en cours.
export const publicEliminationSchema = z.object({
  hunter: publicAgentSchema,
  victim: publicAgentSchema,
  eliminatedAt: isoUtcDateTimeSchema,
});

export type PublicElimination = z.infer<typeof publicEliminationSchema>;
